  /**
 * External dependencies
 */
import { get, omit, forOwn, omitBy, values } from 'lodash';

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.EDIT_LOCATION_WEBSITE]: (state, action) => {
            const id = action.payload.id || '';
            const locationWebsite = action.payload.locationWebsite;
            const newEditLogs = appendToEditsLog(get(state, id), locationWebsite);

            return {
                ...state,
                [id]: newEditLogs,
            };
        },
        [actions.RESET_LOCATION_WEBSITE]: (state, action) => {
            const id = action.payload.id || '';
            return omit(state, id);
        },
    },
);